/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FlowToHireSettings } from '../models/FlowToHireSettings';
import type { FlowToHireSettingsUpdate } from '../models/FlowToHireSettingsUpdate';
import type { FlowToHireStageOptions } from '../models/FlowToHireStageOptions';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FlowToHireSettingsService {

    /**
     * Get Flow to Hire Settings
     * The stage titles and types the account leaves out of the flow-to-hire pipeline count. Admins and super users only.
     * @returns FlowToHireSettings OK
     * @throws ApiError
     */
    public static getInternalApiFountainFlowToHireSettings(): CancelablePromise<FlowToHireSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/fountain/flow_to_hire_settings',
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Update Flow to Hire Settings
     * Replaces both lists and re-runs flow-to-hire for every hiring opening. Admins and super users only.
     * @param requestBody
     * @returns FlowToHireSettings OK
     * @throws ApiError
     */
    public static patchInternalApiFountainFlowToHireSettings(
        requestBody?: FlowToHireSettingsUpdate,
    ): CancelablePromise<FlowToHireSettings> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/internal_api/fountain/flow_to_hire_settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Get Flow to Hire Stage Options
     * The stage types and titles the account can exclude, with the number of hiring openings that use each title. Admins and super users only. Slow on large accounts; load it apart from the settings.
     * @returns FlowToHireStageOptions OK
     * @throws ApiError
     */
    public static getInternalApiFountainFlowToHireSettingsOptions(): CancelablePromise<FlowToHireStageOptions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/fountain/flow_to_hire_settings/options',
            errors: {
                403: `Forbidden`,
            },
        });
    }

}